import { render, staticRenderFns } from "./Story.vue?vue&type=template&id=17d03272&"
import script from "./Story.vue?vue&type=script&lang=js&"
export * from "./Story.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1983107846/src/bitbucket.org/atsuboi/chatbot/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d03272')) {
      api.createRecord('17d03272', component.options)
    } else {
      api.reload('17d03272', component.options)
    }
    module.hot.accept("./Story.vue?vue&type=template&id=17d03272&", function () {
      api.rerender('17d03272', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Story/Story.vue"
export default component.exports